import { AppHeader } from "@/components/layout";
import { PostCardSkeleton } from "@/components/social";
import { Card, Skeleton } from "@/components/ui";

export function CommunityPageSkeleton() {
  return (
    <>
      <AppHeader />
      <main className="mx-auto min-w-0 max-w-7xl px-4 py-6 sm:px-6">
        <Skeleton className="aspect-16/5 w-full rounded-lg" />
        <div className="mt-4 space-y-3">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-5 w-full max-w-xl" />
          <Skeleton className="h-4 w-40" />
        </div>
        <Card padded={false} className="mt-6">
          <div className="h-12 border-b border-border" />
        </Card>
        <div className="mt-4 space-y-4">
          <PostCardSkeleton variant="media" />
          <PostCardSkeleton />
          <PostCardSkeleton variant="media" />
        </div>
      </main>
    </>
  );
}
